// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-container[data-v-844a74e0] {\n  display: flex !important;\n  gap: 1rem !important;\n}\n.description[data-v-844a74e0] {\n  width: 50ch;\n  word-wrap: break-word;\n}", ""]);
// Exports
module.exports = exports;
